export default __webpack_public_path__ + "static/media/patita_gato.7bf1fa2b.svg";